import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../../components/ui/button';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../../components/ui/card';
import { analytics } from '../../services/analytics';
import SEOPageLayout from '../../components/SEOPageLayout';

const LandscapingPackages = () => {
  useEffect(() => {
    analytics.track('Template Page View', { template: 'Landscaping Maintenance Packages' });
  }, []);

  return (
    <SEOPageLayout
      title="Landscaping Maintenance Packages Template - Recurring Revenue | QuoteTier"
      description="Secure year-round revenue with this landscaping maintenance contract template. Offer Basic, Enhanced, and Premium seasonal care packages."
      canonical="/templates/landscaping-maintenance-packages"
      ogTitle="Landscaping Contracts That Stick"
      ogDescription="Don't just mow lawns. Sell total lawn care. Use this template to upsell fertilization, pruning, and seasonal cleanups."
    >
      <section className="py-32 md:py-40 lg:py-48">
        <div className="container max-w-7xl mx-auto px-4">
          <div className="text-center max-w-4xl mx-auto">
            <h1 className="font-instrument text-4xl sm:text-5xl md:text-6xl lg:text-7xl tracking-tight leading-tight mb-6">
              Landscaping <span className="text-primary font-bold">Maintenance</span> Template
            </h1>
            <p className="font-jetbrains text-xl md:text-2xl text-gray-600 tracking-tight leading-relaxed mb-8">
              Turn one-off mow-and-blow jobs into profitable, year-round maintenance contracts.
            </p>
            <div className="font-instrument mt-12 flex flex-col sm:flex-row gap-6 justify-center items-center mb-6">
              <Link to="/signup">
                <Button className="px-8 py-4 text-xl font-semibold bg-black text-white hover:bg-gray-800 rounded-lg shadow-lg">
                  Use This Template Free
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </section>

      <section className="py-16 md:py-24 bg-gray-50">
        <div className="container max-w-6xl mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="font-instrument text-3xl md:text-4xl font-bold mb-4">Recurring Revenue Models</h2>
          </div>

          <div className="grid gap-6 md:grid-cols-3">
            <Card className="border border-black">
              <CardHeader><CardTitle className="font-instrument text-xl">Basic Care</CardTitle><CardDescription>Weekly Service</CardDescription></CardHeader>
              <CardContent>
                  <ul className="font-jetbrains text-sm text-gray-600 list-disc list-inside">
                      <li>Weekly Mowing</li>
                      <li>Edging & Trimming</li>
                      <li>Blowing Debris</li>
                      <li>25 Visits / Year</li>
                  </ul>
              </CardContent>
            </Card>
            <Card className="border border-black bg-black text-white">
              <CardHeader><CardTitle className="font-instrument text-xl text-white">Enhanced</CardTitle><CardDescription className="text-gray-300">Total Lawn Health</CardDescription></CardHeader>
              <CardContent>
                  <ul className="font-jetbrains text-sm text-gray-300 list-disc list-inside">
                      <li>Everything in Basic</li>
                      <li>5-Step Fertilization</li>
                      <li>Weed Control</li>
                      <li>Aeration & Overseeding</li>
                  </ul>
              </CardContent>
            </Card>
            <Card className="border border-black">
              <CardHeader><CardTitle className="font-instrument text-xl">Premium Estate</CardTitle><CardDescription>Full Management</CardDescription></CardHeader>
              <CardContent>
                  <ul className="font-jetbrains text-sm text-gray-600 list-disc list-inside">
                      <li>Everything in Enhanced</li>
                      <li>Shrub Pruning (3x/year)</li>
                      <li>Spring & Fall Cleanup</li>
                      <li>Mulch Installation</li>
                  </ul>
              </CardContent>
            </Card>
          </div>
        </div>
      </section>

      <section className="py-16 md:py-24 bg-black text-white">
        <div className="container max-w-4xl mx-auto px-4 text-center">
          <h2 className="font-instrument text-3xl md:text-4xl font-bold mb-6">Grow Your Maintenance Route</h2>
          <Link to="/signup">
            <Button className="px-10 py-4 font-instrument text-xl font-semibold bg-white text-black hover:bg-gray-200 rounded-lg shadow-lg">
              Get Free Access
            </Button>
          </Link>
        </div>
      </section>
    </SEOPageLayout>
  );
};

export default LandscapingPackages;
